import inherited from 'mastodon/locales/lv.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
